// extracted by mini-css-extract-plugin
export var section = "content-module--section--2XAjD";
export var inner = "content-module--inner--1caX7";
export var articleWrap = "content-module--articleWrap--2TEII";
export var asideWrap = "content-module--asideWrap--2ehi-";